"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateOrNullEqual = void 0;
function isDateOrNullEqual(value, compareToValue) {
    if (value === null && compareToValue === null)
        return true;
    if (value === null)
        return false;
    if (compareToValue === null)
        return false;
    const date1 = value.getTime();
    const date2 = compareToValue.getTime();
    if (date1 === date2) {
        return true;
    }
    return false;
}
exports.isDateOrNullEqual = isDateOrNullEqual;
//# sourceMappingURL=isDateOrNullEqual.js.map